import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CallingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Calling",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m3.68 4.3 1.63-1.63C5.73 2.25 6.3 2 6.94 2s1.21.26 1.63.67l4.36 4.36c.42.42.68 1 .68 1.63s-.26 1.22-.68 1.63l-3.18 3.18c-.28.28-.46.67-.46 1.09s.17.81.46 1.09l6.55 6.55a1.543 1.543 0 0 0 2.18 0l3.18-3.18c.42-.42 1-.68 1.63-.68s1.22.26 1.63.68l4.38 4.37c.42.42.68 1 .68 1.63s-.26 1.22-.68 1.63l-1.65 1.63c-1.74 1.74-4.56 2.12-7.77 1.22-1.18-.33-2.2-.71-3.17-1.18l.11.05a27.8 27.8 0 0 1-7.72-5.54 28 28 0 0 1-5.47-7.57l-.07-.16c-.23-.47-.42-.93-.61-1.41-1.45-3.86-1.34-7.38.7-9.42Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.18 17.11c-.23 0-.46-.07-.66-.21a1.15 1.15 0 0 1-.27-1.59 7.05 7.05 0 0 0-.75-9.1 7.06 7.06 0 0 0-9.1-.75c-.52.37-1.23.25-1.59-.27a1.13 1.13 0 0 1 .27-1.59 9.33 9.33 0 0 1 12.04 1 9.33 9.33 0 0 1 1 12.04c-.22.31-.58.48-.93.48Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.1 13.03c-.09 0-.19-.01-.28-.04-.61-.16-.98-.78-.83-1.39.15-.58.01-1.14-.37-1.52-.55-.55-1.25-.44-1.52-.37a1.14 1.14 0 0 1-1.39-.83c-.16-.61.21-1.23.83-1.39 1.37-.35 2.75.02 3.7.97.96.96 1.32 2.34.97 3.7-.13.52-.6.86-1.11.86ZM21.13 29.85a8.13 8.13 0 0 1-5.77-2.38L4.24 16.35a8.12 8.12 0 0 1-1.45-9.56 1.14 1.14 0 1 1 2.02 1.06 5.84 5.84 0 0 0 1.05 6.88l11.12 11.12c1.11 1.11 2.58 1.72 4.15 1.72s3.04-.61 4.15-1.72l1.25-1.25-4.26-4.26a3.47 3.47 0 0 1-4.8-.12l-6.01-6.01a3.45 3.45 0 0 1-1.02-2.46c0-.87.32-1.69.9-2.33L6.3 4.38c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l5.84 5.85c.45.45.45 1.17 0 1.62l-.68.69c-.23.23-.35.53-.35.84s.12.62.35.84l6.01 6.01c.45.45 1.18.47 1.65.04l.79-.73c.45-.41 1.15-.4 1.58.04l5.84 5.84a1.16 1.16 0 0 1 0 1.62l-2.05 2.05a8.13 8.13 0 0 1-5.77 2.38"
      })]
    })
  }));
};
CallingIcon.displayName = 'CallingIcon';